import { useCallback } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { State } from "./state";
import { AppDispatch } from "./store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<State> = useSelector;

export function useAppSelectorWithArgs<R, A extends unknown[]>(
    selector: (state: State, ...args: A) => R,
    ...deps: A
) {
    const memoizedSelector = useCallback(
        (state: State) => selector(state, ...deps),
        // Lint error suppressed on purpose
        // eslint-disable-next-line react-hooks/exhaustive-deps
        deps
    );
    return useAppSelector(memoizedSelector);
}
